import {makeAutoObservable, observable} from 'mobx'
import {observer} from 'mobx-react-lite'
import React from 'react'

/**
 * Store is responsible for rendering popups
 */
class PopupHostStore {
  renderQueue: React.ComponentType[] = []

  constructor() {
    makeAutoObservable(
      this,
      {
        renderQueue: observable.shallow // shallow, так как компоненты не оборачиваем
      },
      {autoBind: true}
    )
  }

  addPopup(popup: React.ComponentType): () => void {
    this.renderQueue.push(popup)
    return () => {
      const index = this.renderQueue.indexOf(popup)
      if (index !== -1) {
        this.renderQueue.splice(index, 1)
      }
    }
  }
}

export const popupHost = new PopupHostStore()

/**
 * Host for rendering popups. Should be placed at the top of the application once.
 * Is a part of the createReactPopup function used in UI Api.
 */
export const PopupHost = observer(() => {
  const Popup = popupHost.renderQueue[0]
  return Popup ? <Popup /> : null
})
